import { createElement, type CSSProperties, type ReactNode } from "react";
import type { Theme } from "@mui/material/styles";

/** Free seats / not-set fill — light grey in light mode, muted in dark (avoids glow). */
export function getManagementNeutralChartFill(theme: Theme): string {
  return theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[300];
}

/** Recharts tooltip styles that stay readable in light and dark mode. */
export function getManagementChartTooltipProps(theme: Theme): {
  contentStyle: CSSProperties;
  itemStyle: CSSProperties;
  labelStyle: CSSProperties;
} {
  return {
    contentStyle: {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary
    },
    // Override Recharts default `entry.color || '#000'` so labels stay readable on paper.
    itemStyle: { color: theme.palette.text.primary },
    labelStyle: { color: theme.palette.text.secondary, fontWeight: 600 }
  };
}

/**
 * Recharts legend label color. Default Legend inherits the series stroke/fill
 * (often a muted secondary grey) for the text — force primary ink instead.
 */
export function getManagementChartLegendProps(theme: Theme): {
  wrapperStyle: CSSProperties;
  formatter: (value: string) => ReactNode;
} {
  const labelColor = theme.palette.text.primary;
  return {
    wrapperStyle: { color: labelColor },
    formatter: (value: string) => createElement("span", { style: { color: labelColor } }, value)
  };
}
